// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"161":"f72ce9f0cbd8f143","714":"52670f73ceb73dda","719":"dd611c9893fdcf5f"}[chunkId] + ".js";
};